import { useMemo } from 'react';
import { useSession } from 'auth/AuthProvider';

interface ReportParams {
    type: 'class' | 'organization';
    id: string;
}

interface UseReportParamsProps {
    classId: string | null;
    startDate: string | null;
    endDate: string | null;
}

export const useReportParams = ({ classId, startDate, endDate }: UseReportParamsProps): ReportParams | null => {
    const session = useSession();

    return useMemo(() => {
        // Validate required parameters
        if (!startDate || !endDate) {
            return null;
        }

        // For managers: if classId provided, create class report; otherwise organization report
        if (session.role === 'manager' && session.organization_id) {
            if (classId) {
                return {
                    type: 'class',
                    id: classId
                };
            } else {
                return {
                    type: 'organization',
                    id: session.organization_id
                };
            }
        }

        // For teachers: create class reports only if classId is provided
        if (session.role === 'teacher' && classId) {
            return {
                type: 'class',
                id: classId
            };
        }

        // Invalid combination - no valid parameters
        return null;
    }, [session.role, session.organization_id,classId, startDate, endDate]);
};